// Réglages de l'éditeur de texte riche Rhino (Action Text), à importer AVANT
// "rhino-editor" : l'événement rhino-before-initialize part dès que l'élément
// <rhino-editor> est défini, donc l'écouteur doit déjà être en place.
//
// On y ajoute ce que l'éditeur ne propose pas d'origine : plusieurs niveaux de
// titres, les tableaux et l'alignement du texte (extensions TipTap), et on traduit
// ses libellés en français.
import { TableKit } from "@tiptap/extension-table"
import { TextAlign } from "@tiptap/extension-text-align"

const isMac = /Mac|iPhone|iPad/.test(navigator.platform)
const mod = isMac ? "cmd" : "ctrl"

const TRANSLATIONS = {
  attachFiles: "Joindre des fichiers",
  bold: `Gras <${mod}+b>`,
  italics: `Italique <${mod}+i>`,
  strike: `Barré <${mod}+shift+s>`,
  link: `Lien <${mod}+k>`,
  heading: "Titre",
  blockQuote: "Citation",
  code: `Code <${mod}+e>`,
  codeBlock: "Bloc de code",
  bulletList: "Liste à puces",
  orderedList: "Liste numérotée",
  undo: `Annuler <${mod}+z>`,
  redo: `Rétablir <${mod}+shift+z>`,
  linkDialogLink: "Lier",
  linkDialogUnlink: "Retirer le lien",
  placeholder: "Rédigez le contenu...",
  increaseIndentation: "Augmenter le retrait",
  decreaseIndentation: "Diminuer le retrait",
  fileUploadErrorMessage: "Le fichier n'a pas pu être envoyé.",
  captionPlaceholder: "Ajouter une légende..."
}

document.addEventListener("rhino-before-initialize", (event) => {
  const editor = event.target

  // Le titre de la page est déjà un <h1> : les titres du texte vont de h2 à h4.
  editor.starterKitOptions = { ...editor.starterKitOptions, heading: { levels: [2, 3, 4] } }
  editor.defaultHeadingLevel = 2
  editor.translations = { ...editor.translations, ...TRANSLATIONS }
  editor.addExtensions(
    TableKit.configure({ table: { resizable: false } }),
    TextAlign.configure({ types: ["heading", "paragraph"] })
  )
})
